module.exports = __webpack_public_path__ + "img/living-room-house.ea9a85b4.jpg";